<template>
  <div class="loadpage">
    <div v-loading="loading" class="pagess" element-loading-text="页面跳转中..."></div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      loading: true,
       ruleForm2: {
        username: "",
        password: "",
      },
    };
  },
  computed: {

  },
  created() {
    this.gettoken()
  },
  methods: {
    gettoken(token) {
        const params= this.$route.query;
      this.$http.otherAhmu(params)
        .then(res => {
          if (res.code ==200) {
      this.ruleForm2.username=res.data.username
      this.ruleForm2.password='123456'
      this.ruleForm2.school_id='100001'
      //登录
      this.loginHandler()
          } else {
            this.$message.error(res.message)
          }

        })
    },
    loginHandler() {
      let params = {
        username: this.ruleForm2.username,
        password: this.ruleForm2.password,
          school_id: this.ruleForm2.school_id

      };
      this.$http
        .userLogin(params)
        .then(res => {
          if (res.code ==200) {
            for (let key in res.data) {
              this.$cookies.set(key, res.data[key]);
            }
            this.getUserInfo();
          } else this.$message.error(res.message);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getUserInfo() {
     const courseId =this.$route.params.detailId
      this.$http.getUserInfo().then(res => {
        // 分发actions中getUserInfo方法  找store/index.js
        this.$store.dispatch("SetUserInfo", res.data);
        //返回之前的前面
        this.$router.push({
          path: `/courses/${courseId}/details-introduce`,
        })
      });
    },

  },
};
</script>

<style  lang="less">
.loadpage {
  .ts {
    text-align: center;
  }
  .pagess {
    height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assessment/targetpage.vue